import React, {useState, useEffect, useRef} from 'react';
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Dropdown} from "primereact/dropdown";
import axios from "axios";

const MachinelogListComponent = (props) => {

  const {t} = props;
  const [machinelogs, setMachinelogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      apiCall('get', '/api/v2/machine-log' + query)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setMachinelogs(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  // const actionBodyTemplate = (rowData) => {
  //   return (
  //     <React.Fragment>
  //       {localStorage.getItem('roles').toString().includes('role_') &&
  //         <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
  //                 tooltip={t('edit')} tooltipOptions={{position: 'left'}}
  //                 onClick={() => {
  //                   if(entity === 'tmp') {
  //                     history.push('/inventory/tmp/update/' + rowData.id)
  //                   }
  //                 }}/>
  //       }
  //       {localStorage.getItem('roles').toString().includes('role_') &&
  //         <Button icon="pi pi-trash" className="p-button-danger"
  //                 tooltip={t('delete')} tooltipOptions={{position: 'left'}}
  //                 onClick={() => {
  //                   if (window.confirm('A törlés megerősítésére van szükség!')) {
  //                     setLoading(true);
  //                     apiCall('delete', '/api/v2/tmp/' + rowData.id)
  //                       .then(response => {
  //                         window.App.toastShow('success', 'Sikeres törlés!');
  //                         window.App.setState({rerenderTmpList: Math.random()})
  //                       })
  //                       .catch(error => {
  //                         window.App.toastShow('error', t('error'), error.toString(), '', error.response);
  //                       })
  //                       .finally(() => {
  //                         setLoading(false);
  //                       })
  //                   }
  //                 }}
  //         />
  //       }
  //     </React.Fragment>
  //   );
  // }

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderMachinelogList])

  return (
    <>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={machinelogs} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 dataKey="id"
      >

        <Column field="issue_date" header={t('columnDateAndTime')} sortable body={(rowData) => {
          return (
            <>{rowData.issue_date ? window.App.formatDateValue(rowData.issue_date) : ''}</>
          )
        }}></Column>
        <Column field="machine.name" header={t('columnMachine')} sortable filter></Column>
        <Column field="employee.name" header={t('columnEmployee')} sortable filter></Column>
        <Column field="project_number" header={t('columnProjectNumber')} sortable filter></Column>
        <Column field="operation" header={t('columnOperation')} sortable filter body={(row) => <div>{row.operation}{row.note && <div className="text-sm mt-1">{row.note}</div>}</div>}></Column>
        <Column field="main_time" header={t('columnMainTime')} sortable filter></Column>
        <Column field="auxiliary_time" header={t('columnAuxiliaryTime')} sortable filter></Column>
        <Column field="down_time" header={t('columnDowntime')} sortable filter></Column>
        {/* <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column> */}
      </DataTable>
    </>
  )
}
export default withTranslation('common')(MachinelogListComponent);
